import { NgStyle } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { ThemePipe } from 'src/app/core/pipes/theme.pipe';

@Component({
  selector: 'app-tutorial-slide-content',
  templateUrl: './tutorial-slide-content.component.html',
  styleUrls: ['./tutorial-slide-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe],
})
export class TutorialSlideContentComponent {
  imageUrl = input.required<string>();
  description = input.required<string>();
  altText = input('Tutorial');

  readonly descriptionStyles: [string, string][] = [
    ['type', 'drawer-tutorial-body'],
    ['text-color', 'drawer-tutorial-body'],
  ];
}
